/** Создает строку для window.Telegram.WebApp.initDataUnsafe.start_param */
export const composeStartParam = (
  referralKey: string | null,
  boxId: number | null,
) => {
  if (referralKey && boxId !== null) {
    return `zyn_${referralKey}_box_${boxId}`
  }
  if (referralKey) {
    return `zyn_${referralKey}`
  }
  if (boxId !== null) {
    return `box_${boxId}`
  }
  return ''
}

/** Парсит строку из window.Telegram.WebApp.initDataUnsafe.start_param */
export const parseStartParam = (param: string | undefined) => {
  if (!param) {
    return { ref: null, box: null }
  }

  try {
    // Формат: zyn_XXX_box_YYY, zyn_XXX, или box_YYY
    let ref: string | null = null
    let box: string | null = null

    // Проверяем наличие referral key
    if (param.includes('zyn_')) {
      // Извлекаем ref: либо между 'zyn_' и '_box_', либо до конца строки
      const refMatch = /zyn_([^_]+)(?:_box_|$)/.exec(param)
      ref = refMatch?.[1] ?? null
    }

    // Извлекаем box после 'box_'
    const boxMatch = /box_(\d+)/.exec(param)
    box = boxMatch?.[1] ?? null

    return {
      ref,
      box,
    }
  } catch (error) {
    throw new Error(`Failed to parse start parameter: ${error}`)
  }
}

/**
 * Парсит URL query параметры для browser-based ссылок
 * Format: ?zyn=XXX or ?zyn=XXX&box=YYY or /box/123?zyn=XXX
 *
 * @example
 * // URL: https://app.votebox.io/?zyn=abc123
 * parseUrlParams() // { ref: 'abc123', box: null }
 *
 * @example
 * // URL: https://app.votebox.io/box/456?zyn=abc123
 * parseUrlParams() // { ref: 'abc123', box: '456' }
 */
export const parseUrlParams = (): {
  ref: string | null
  box: string | null
} => {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const ref = urlParams.get('zyn')

    // Box can come from URL param or from path like /box/123 or /box/EQAddress...
    let box = urlParams.get('box')
    if (!box) {
      const boxMatch = /\/box\/([^/]+)/.exec(window.location.pathname)
      box = boxMatch?.[1] ?? null
    }

    return {
      ref: ref || null,
      box: box || null,
    }
  } catch {
    return { ref: null, box: null }
  }
}
